import { useState, useCallback, useEffect } from "react";
import { ImgLoadStatus } from "../constants/constants.js";
const useLoadImage = ({
  src,
  onLoad,
  onError
}) => {
  const [imgLoadStatus, setImgLoadStatus] = useState();
  const handleImgLoad = useCallback(
    (event) => {
      setImgLoadStatus(ImgLoadStatus.loaded);
      onLoad == null ? void 0 : onLoad(event);
    },
    [onLoad]
  );
  const handleImgLoadError = useCallback(
    (event) => {
      setImgLoadStatus(ImgLoadStatus.loadError);
      onError == null ? void 0 : onError(event);
    },
    [onError]
  );
  useEffect(() => {
    if (!src)
      return;
    const img = new Image();
    img.addEventListener("load", handleImgLoad);
    img.addEventListener("error", handleImgLoadError);
    img.src = src;
    setImgLoadStatus(ImgLoadStatus.loading);
    return () => {
      img.removeEventListener("load", handleImgLoad);
      img.removeEventListener("error", handleImgLoadError);
    };
  }, [handleImgLoad, handleImgLoadError, src]);
  return {
    loadStatus: imgLoadStatus
  };
};
export {
  useLoadImage
};
//# sourceMappingURL=useLoadImage.js.map
